


let langs = [];

const set = (langsData) => {
  langs = langsData;
}

const clear = () => {
  langs = [];
}

const get = () => {
  return langs;
}

const SetLangsLive = {
  set,
  get,
  clear
};

export default SetLangsLive;



// WEBPACK FOOTER //
// ./src/components/EventOptions/components/SetLangsLive.js